
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/zohocrm",
      function () {
        return require("private-next-pages/destinations/zohocrm.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/zohocrm"])
      });
    }
  